'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function (_React$Component) {
    (0, _inherits3.default)(_default, _React$Component);

    function _default() {
        (0, _classCallCheck3.default)(this, _default);
        return (0, _possibleConstructorReturn3.default)(this, (_default.__proto__ || (0, _getPrototypeOf2.default)(_default)).apply(this, arguments));
    }

    (0, _createClass3.default)(_default, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'svg',
                { viewBox: '-361 253.8 76.2 94.2', enableBackground: 'new -361 253.8 76.2 94.2' },
                _react2.default.createElement('ellipse', { opacity: '0.15', cx: '-331', cy: '344.5', rx: '30', ry: '3.5' }),
                _react2.default.createElement(
                    'g',
                    null,
                    _react2.default.createElement('path', { d: 'M-346,327.8h28v-51h-28V327.8z M-344,278.8h24v47h-24V278.8z' }),
                    _react2.default.createElement('circle', { cx: '-332', cy: '333.3', r: '3' }),
                    _react2.default.createElement('path', { d: 'M-313,299.3v35.2c0,3.3-2.7,6-6,6h-26c-3.3,0-6-2.7-6-6v-57c0-3.3,2.7-6,6-6h17.5v-4H-345c-5.5,0-10,4.5-10,10v57 c0,5.5,4.5,10,10,10h26c5.5,0,10-4.5,10-10v-35.2H-313z' })
                ),
                _react2.default.createElement(
                    'g',
                    null,
                    _react2.default.createElement('path', { d: 'M-310,253.8c-13.9,0-25.2,11.3-25.2,25.2c0,5.5,1.8,10.5,4.7,14.7l-1.3,10l10.7-2.1c3.3,1.6,7.1,2.6,11.1,2.6 c13.9,0,25.2-11.3,25.2-25.2S-296.1,253.8-310,253.8z M-310,293c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S-308.3,293-310,293z M-308,284h-4l-1-19h6L-308,284z' })
                )
            );
        }
    }]);
    return _default;
}(_react2.default.Component);

exports.default = _default;